export const IOS_CARD_DOWNLOAD = "ios_card_download";
export const ANDROID_CARD_DOWNLOAD = "android_card_download";
export const ANDROID_CARD_DOWNLOAD_ISSUER = "issuer";
export const ANDROID_CARD_DOWNLOAD_JWT = "jwt";
export const GA_USER_ID = "gauid";
